import { styled } from '@mui/system';
import MuiDialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';

export const ContentWrapper = styled(MuiDialogContent)(() => ({}));

export const LoadingContentWrapper = styled(MuiDialogContent)(() => ({
  filter: 'blur(5px)',
  pointerEvents: 'none'
}));

export const AlertDialogContent = styled('div')(() => ({
  padding: '16px 0',
  '& p:nth-of-type(1)': {
    color: '#000',
    fontWeight: 500
  },
  '& p:nth-of-type(2)': {
    color: '#000000de'
  }
}));

export const AlertFormControl = styled(FormControl)(() => ({
  width: '100%',
  '& legend': {
    width: 50
  }
}));

export const WithdrawConfirmation = styled('div')(() => ({
  padding: '8px 0'
}));

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  gap: 16
}));

export const AlertConfirmButton = styled(Button)(() => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  width: 80,
  backgroundColor: '#FAFAFA',
  borderRadius: 0,
  boxShadow: 'rgba(0, 0, 0, 0.30) -17px 17px 20px -22px',
  color: '#0000008a',
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
  '&:hover': {
    backgroundColor: '#FFF'
  }
}));

export const ButtonWrapper = styled('div')(() => ({
  flex: '0 0 20%'
}));
